import { useAxios } from './axiosService';

const BASE = '/admin/vin-extraction';

/**
 * Super Admin VIN extraction page: settings, the processing switch and the read routes. Every call shows its
 * own errors on the page (a 403 for a Super Admin without 2FA renders an explanation, not the error page).
 */
export const useVinExtractionService = () => {
    const { axios: instance } = useAxios();
    const own = { skipGlobalErrorHandler: true };

    const getSettings = async () => (await instance.get(`${BASE}/settings`, own)).data;
    const updateSettings = async body => (await instance.patch(`${BASE}/settings`, body, own)).data;
    // the page's one switch drives the batch job only; polling keeps collecting results already paid for
    const setProcessing = async on =>
        (await instance.post(`/vin-scheduler/processing/${on ? 'start' : 'stop'}`, null, own)).data;
    // one batch with the saved settings while the switch stays off; answers { jobId, cars }
    const runTestBatch = async carLimit => (await instance.post('/vin-scheduler/test-batch', { carLimit }, own)).data;
    const getStats = async ({ from, to, tz }) =>
        (await instance.get(`${BASE}/stats`, { params: { from, to, tz }, ...own })).data;
    const getBatches = async ({ from, to, result, page, pageSize }) =>
        (await instance.get(`${BASE}/batches`, { params: { from, to, result, page, pageSize }, ...own })).data;
    const getBatchCars = async (batchId, { status, search, page, pageSize }) =>
        (
            await instance.get(`${BASE}/batches/${encodeURIComponent(batchId)}/cars`, {
                params: { status, search, page, pageSize },
                ...own,
            })
        ).data;
    const getCarDocuments = async carId =>
        (await instance.get(`${BASE}/cars/${encodeURIComponent(carId)}/documents`, own)).data;

    return {
        getSettings,
        updateSettings,
        setProcessing,
        runTestBatch,
        getStats,
        getBatches,
        getBatchCars,
        getCarDocuments,
    };
};
